// DS: DEV10
import React from 'react';
import { Props as IconWrapProps } from '@wix/da-ds/pkg/Icons/IconWrap';

import StatisticsBarItem from './StatisticsBarItem';

import s from './StatisticsBar.scss';

export type StatItem =
  | {
      icon: React.ComponentType<IconWrapProps>;
      label: string;
    }
  | false
  | undefined;

export interface Props {
  stats: StatItem[];
  className?: string;
}

const StatisticsBar: React.FC<Props> = ({ stats, className }) => (
  <div className={className}>
    {stats.map(
      stat =>
        stat && (
          <StatisticsBarItem
            key={stat.label}
            icon={stat.icon}
            label={stat.label}
            className={s['stat-item']}
          />
        )
    )}
  </div>
);
StatisticsBar.displayName = 'StatisticsBar';

export default StatisticsBar;
